import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const RootRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Partner users go to tasks, others to dashboard
  const redirectPath = user?.role === 'partner' ? '/tasks' : '/dashboard';
  return <Navigate to={redirectPath} replace />;
};

export default RootRedirect;
